


















import Component from 'vue-class-component';

// The base for every action
import ActionBase from './ActionBase.vue';

/**
 *  The trash icon to invoke a remove action.
 */
@Component
export default class ActionRemove extends ActionBase {}
